import * as angular from "angular";

let PlannerTabsComponent = {
    selector: "vcPlannerTabs",
    templateUrl: "/angular/components/planner/planner-tabs.component.html",
    bindings: {
        activeTab: "=?",
    },
    controller: class PlannerTabsController {
        // * bindings for typescript compiler *
        public activeTab?: any;
        // ************************************
        private readonly $scope: any;
        private $window: any;

        constructor($scope: any, $window: any, __app_type: string) {
            this.$scope = $scope;
            this.$window = $window;
        }

        navigateTo(location: string): void {
            this.$window.location = "/#/" + location;
        }
    },
};

angular
    .module("planner")
    .component(PlannerTabsComponent.selector, PlannerTabsComponent);
